// The desktop app (desktop/ at the repo root) is an Electron window around this
// web app. Its preload script exposes window.nanaDesktop; in a browser it's
// undefined and none of this does anything.

type DesktopBridge = {
  platform: string
  version: string | null
  isFullScreen: () => boolean
  onFullScreenChange: (listener: (isFullScreen: boolean) => void) => () => void
  onNavigate: (listener: (path: string) => void) => () => void
}

declare global {
  interface Window {
    nanaDesktop?: DesktopBridge
  }
}

export const isDesktopApp = (): boolean => window.nanaDesktop != null

export const desktopAppVersion = (): string | null => window.nanaDesktop?.version ?? null

// The classes put on <html> here drive the desktop styles at the end of
// application.tailwind.css: drag regions, room for the window controls, cursors.
export function setupDesktopApp(navigate: (path: string) => void) {
  const desktop = window.nanaDesktop
  if (!desktop) return

  const root = document.documentElement
  root.classList.add("desktop-app", `desktop-app-${desktop.platform}`)

  const setFullScreen = (isFullScreen: boolean) =>
    root.classList.toggle("desktop-app-fullscreen", isFullScreen)
  setFullScreen(desktop.isFullScreen())
  desktop.onFullScreenChange(setFullScreen)

  // The Go menu (Cmd-1 to Cmd-5) and Settings (Cmd-,).
  desktop.onNavigate(navigate)
}
